var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 7.99992V3.83259C13.3327 3.77996 13.3224 3.72785 13.3022 3.67923C13.2821 3.63061 13.2526 3.58644 13.2153 3.54925L11.1167 1.45059C11.0417 1.37555 10.9401 1.33335 10.834 1.33325H3.06602C2.95993 1.33325 2.85819 1.37539 2.78317 1.45041C2.70816 1.52542 2.66602 1.62717 2.66602 1.73325V14.2666C2.66602 14.3727 2.70816 14.4744 2.78317 14.5494C2.85819 14.6244 2.95993 14.6666 3.06602 14.6666H8.66602M5.33268 6.66658H10.666M5.33268 3.99992H7.99935M5.33268 9.33325H7.33268",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 1.33325V3.59992C10.666 3.70601 10.7082 3.80775 10.7832 3.88276C10.8582 3.95778 10.9599 3.99992 11.066 3.99992H13.3327M13.3273 10.0833L15.0313 10.5159C15.2087 10.5613 15.3333 10.7226 15.328 10.9053C15.2133 14.7439 12.9993 15.3333 12.9993 15.3333C12.9993 15.3333 10.7853 14.7439 10.6707 10.9053C10.6689 10.8164 10.6972 10.7295 10.7511 10.6588C10.8049 10.5881 10.8812 10.5377 10.9673 10.5159L12.6713 10.0833C12.8867 10.0286 13.112 10.0286 13.3273 10.0833Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/aboutIcon.47e373363aec47ef81ceb93ee408aa27.svg";
export { ForwardRef as ReactComponent };